import { useTheme } from "@mui/material";

export const UseIconButtonStyles = (
  icon: string,
  status?: string,
  disabled?: boolean,
) => {
  const theme = useTheme();

  const getIconColor = () => {
    if (disabled) return theme.palette.action.disabled;
    switch (icon) {
      case "delete":
        switch (status?.toLowerCase()) {
          case "delete":
            return theme.palette.error.main;
          default:
            return theme.palette.text.icon;
        }

      // case "AssignmentTurnedIn":
      //   switch (status?.toLowerCase()) {
      //     case "completed":
      //       return "#A6FF03";
      //     case "pending":
      //       return "#0000FF";
      //     default:
      //       return "#ffffff";
      //   }

      default:
        return theme.palette.text.primary;
    }
  };

  return {
    ".MuiSvgIcon-root": {
      fill: `${getIconColor()} !important`,
    },
  };
};
